
// This function calculates icon positions in polar coordinates
function CalculatePositions(data, middleRadius, circleWidth, circleWidthImpacts) {

  const positions = {};


  for(let typeNR=1;typeNR<5;typeNR++){

    const circleData = data.filter(d => +d.typenr === typeNR);

    let radius = middleRadius + circleWidth * ((typeNR*2-1) - 0.5);
    if(typeNR === 4){
      // adjust the radius to the bigger size of the impact icons
      radius += circleWidthImpacts/2 - circleWidth/2 + circleWidth/14;
    }
    const noOfIconsInCircle = circleData.length;

    // const positionsInThisCircle = {}
    circleData.forEach((d, i) => {
      positions[d.ID] = [radius,((2*Math.PI/noOfIconsInCircle) * i)]
    })

  }
  return positions;
}

export default CalculatePositions;
